import { Signal } from '@preact/signals-react';
import loaderSignal from 'signals/Loader.signal';
import applicationDetailSignal from '../../ApplicationDetail/ApplicationDetail.signal';
import api from 'api/api';
import alertSignal from 'signals/Alert.signal';
import { getNotesRoute, refreshListAndModal } from '../Approvable.helpers';

export const handleSendNoteSubmission = async (
  content: string,
  opts?: { internalUseOnly?: boolean }
): Promise<Signal<unknown>> => {
  loaderSignal.update({ isContentLoading: true, message: 'Sending note...' });
  try {
    const { id, modelType, ventureCapitalist } = applicationDetailSignal.value;
    await api.post({
      path: getNotesRoute(modelType, id),
      body: {
        ...(modelType === 'application'
          ? {
              data: {
                content,
                ...(opts?.internalUseOnly ? { internalUseOnly: true } : {}),
              },
            }
          : { programRequestId: id, content }),
      },
    });

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    await refreshListAndModal(id!, modelType, ventureCapitalist);

    return alertSignal.update({
      variant: 'success',
      type: 'notification',
      message: 'Successfully added note',
    });
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      error,
      // @ts-ignore
      message: error.message,
    });
  } finally {
    loaderSignal.reset();
  }
};

export const handleUpdateNoteSubmission = async (
  uuid: string,
  content: string,
  internalUseOnly?: boolean
): Promise<Signal<unknown>> => {
  loaderSignal.update({ isContentLoading: true, message: 'Updating note...' });
  try {
    const { id, modelType, ventureCapitalist } = applicationDetailSignal.value;
    if (modelType !== 'application' || !id) {
      return alertSignal.update({
        type: 'notification',
        message: 'Cannot update note',
      });
    }
    await api.patch({
      path: `/applications/${id}/notes`,
      body: {
        data: {
          uuid,
          content,
          ...(typeof internalUseOnly === 'boolean' ? { internalUseOnly } : {}),
        },
      },
    });

    await refreshListAndModal(id, modelType, ventureCapitalist);

    return alertSignal.update({
      variant: 'success',
      type: 'notification',
      message: 'Note updated',
    });
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      error,
      // @ts-ignore
      message: error.message,
    });
  } finally {
    loaderSignal.reset();
  }
};
